import { HTTPClient } from "@abaco/web-common/src/HTTP";

export interface ExchangeUrlResponse {
    token: string;
    envUrl: string;
}

export default class TokenApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async exchangeSsoToken(): Promise<ExchangeUrlResponse> {
        const url = "/malta-scp-2-a4f-api/api/v1/malta-scp2a4f/exchange-sso-token";
        const res = await this.http.get(url);
        return res.data;
    }
}
